import { merge } from 'lodash';
import {
  ChartOptions, PlotOptions, XAxisOptions, YAxisOptions,
} from 'highcharts';

import { getBaseGraphConfig } from 'components/common/Graphs/graphConfigs';
import * as K from 'common/constants';

/**
 * Timeline config file with static options
 * Series should be set dynamically when used.
 */
const CHART: ChartOptions = {
  type: K.SERIES_TYPES.COLUMN,
  events:       {},
  marginRight:  10,
  height:       85,
  marginTop:    0,
  marginBottom: 26,
  animation:    false,
  zoomType:     'x',
};

const X_AXIS: XAxisOptions = {
  tickWidth:   0.5,
  lineWidth:   0.5,
  minPadding:  0,
  maxPadding:  0,
  zoomEnabled: true,
  labels: {
    style: {
      fontSize: '10',
    },
  },
  crosshair: {
    snap:  false,
    width: 1.5,
    zIndex: 3,
  },
};

const Y_AXIS: YAxisOptions = {
  gridLineWidth:      0.5,
  offset:             20,
  minorGridLineWidth: 0,
  tickPixelInterval:  10,
  tickWidth:          0,
  lineWidth:          0,
  minPadding:         0.5,
  maxPadding:         0,
  startOnTick:        false,
  endOnTick:          false,
  labels: {
    align:   'left',
    x:       0,
    enabled: true,
  },
};

const PLOT_OPTIONS: PlotOptions = {
  column: {
    pointPlacement: 'on',
    pointWidth:     undefined,
    minPointLength: 0,
    showInLegend:   false,
    grouping:       false,
    states: {
      hover: {
        enabled: true,
      },
    },
  },
  line: {
    dashStyle:    'ShortDot',
    showInLegend: false,
    lineWidth:    1.5,
    marker: {
      enabled: false,
    },
    states: {
      hover: {
        enabled: false,
      },
    },
    enableMouseTracking: false,
  },
  series: {
    animation: false,
    marker: {
      enabled: false,
    },
    states: {
      inactive: {
        opacity: 1,
      },
    },
  },
};

const TOOL_TIP = {
  enabled: true,
  shared: true,
  formatter(): boolean {
    return false;
  },
};

const CONFIG = {
  chart:       CHART,
  xAxis:       X_AXIS,
  yAxis:       Y_AXIS,
  plotOptions: PLOT_OPTIONS,
  tooltip:     TOOL_TIP,
};

const TIMELINE_CONFIG = merge(getBaseGraphConfig(), CONFIG);

export default TIMELINE_CONFIG;
